import { BuildPromptSteps } from "@/types/flows";
import { PromptAnnotateDataSidebarContent } from "./Annotate/PromptAnnotateDataSidebarContent";
import { PromptReviewPredictionsSidebarContent } from "./Review/PromptReviewPredictionsSidebarContent";
import { useComputedValues } from "@/contexts/ComputedValuesContext";
import { useEffect } from "react";
import { useFlow } from "@/contexts/FlowContext";
import { useTextPromptMode } from "@/store";

export const PromptSidebarContent = () => {
    const { currentFramePredictions } = useComputedValues();
    const { setFlowLocked } = useFlow();
    const textPromptMode = useTextPromptMode();

    const mode =
        currentFramePredictions.length > 0 && !textPromptMode
            ? BuildPromptSteps.REVIEW_PREDICTIONS
            : BuildPromptSteps.ANNOTATE_DATA;

    useEffect(() => {
        if (mode === BuildPromptSteps.REVIEW_PREDICTIONS) {
            setFlowLocked(true);
        } else {
            setFlowLocked(false);
        }
    }, [mode, setFlowLocked]);

    if (mode === BuildPromptSteps.ANNOTATE_DATA) {
        return <PromptAnnotateDataSidebarContent />;
    }

    return <PromptReviewPredictionsSidebarContent />;
};
